<div class="header-logged-out row align-items-center justify-content-center">
  <ftr-logo [theme]="logoThemes.Themed"></ftr-logo>
  <div class="help-button">
    <button class="elevio__help" ftrTooltip message="Help Center" [showDash]="false" alignment="center" position="left">
      <ftr-icon icon="HelpCircleSolid" color="Primary" align="Top" size="ExtraLarge" [ariaHidden]="true"></ftr-icon>
    </button>
  </div>
</div>
